import { FileOpenOutlined } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Divider,
  IconButton,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowParams,
  GridToolbar,
} from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";
import LoanAccounts from "../components/LoanAccounts";
import ShareAccounts from "../components/ShareAccounts";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AccountActions = ({ params, getSavingsAccount }) => {
  const [open, setOpen] = useState(false);
  const [savingsData, setSavingsData] = React.useState({
    id: params.row.id,
    account_name: params.row.account_name,
    interest_over_a_year: params.row.interest_over_a_year,
    is_refundable: params.row.is_refundable,
    medium_of_exchange: params.row.medium_of_exchange,
    stamp_value: params.row.stamp_value,
    in_out: params.row.in_out,
    in_ex: params.row.in_ex,
    as_li: params.row.as_li,
  });

  const { permissions } = useContext(AuthContext);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setSavingsData({
        ...savingsData,
        [name]: checked,
      });
    } else {
      setSavingsData({
        ...savingsData,
        [name]: value,
      });
    }
  };

  const createSavings = async (event) => {
    event.preventDefault();
    try {
      await api
        .post("/account/savings/edit", savingsData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          setSavingsData({
            id: params.row.id,
            account_name: params.row.account_name,
            interest_over_a_year: params.row.interest_over_a_year,
            is_refundable: params.row.is_refundable,
            medium_of_exchange: params.row.medium_of_exchange,
            stamp_value: params.row.stamp_value,
            in_out: params.row.in_out,
            in_ex: params.row.in_ex,
            as_li: params.row.as_li,
          });
          getSavingsAccount();
          setOpen(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpen = () => {
    if (permissions && permissions.update_savings_account === true) {
      setOpen(true);
    } else {
      toast.error("Not Authorized");
    }
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <EditIcon />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Edit Savings Account</DialogTitle>
        <DialogContent>
          <DialogContentText>
            New Changes might take a couple of minutes to activate after the
            setup.
          </DialogContentText>
          <TextField
            required
            margin="dense"
            id="account_name"
            name="account_name"
            label="Account Name"
            onChange={handleInputChange}
            value={savingsData.account_name}
            type="text"
            fullWidth
            variant="outlined"
          />
          <p>Saves In</p>
          <Select
            required
            margin="dense"
            id="medium_of_exchange"
            name="medium_of_exchange"
            value={savingsData.medium_of_exchange}
            label="Money Type"
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="cash">Cash</MenuItem>
            <MenuItem value="stamps">Stamps</MenuItem>
            <MenuItem value="both">Both</MenuItem>
          </Select>

          <TextField
            required
            margin="dense"
            id="interest_over_a_year"
            name="interest_over_a_year"
            label="Interest Over A Year (%)"
            onChange={handleInputChange}
            type="number"
            value={savingsData.interest_over_a_year}
            fullWidth
            variant="outlined"
          />
          {savingsData.medium_of_exchange === "stamps" ||
          savingsData.medium_of_exchange === "both" ? (
            <TextField
              margin="dense"
              name="stamp_value"
              label="Specify Stamp value"
              onChange={handleInputChange}
              type="number"
              value={savingsData.stamp_value}
              fullWidth
              variant="outlined"
            />
          ) : null}

          <p>Is Refundable?</p>
          <input
            name="is_refundable"
            id="is_refundable"
            type="checkbox"
            value={savingsData.is_refundable}
            onChange={handleInputChange}
          />

              <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={savingsData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={savingsData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={savingsData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={createSavings}>Save Changes</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const Accounts = () => {
  const [value, setValue] = React.useState();
  const [allSavings, setAllSavings] = useState([]);
  const { permissions } = useContext(AuthContext);
  const [open, setOpen] = React.useState(false);
  const [savingsData, setSavingsData] = React.useState({
    account_name: "",
    interest_over_a_year: null,
    is_refundable: false,
    medium_of_exchange: "",
    stamp_value: null,
    in_out: "",
    in_ex: "",
    as_li: "",
  });
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setSavingsData({
        ...savingsData,
        [name]: checked,
      });
    } else {
      setSavingsData({
        ...savingsData,
        [name]: value,
      });
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getSavingsAccount = async () => {
    try {
      await api
        .get("/account/savings/getall", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAllSavings(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSavingsAccount();
  }, []);

  const savingsColumns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "account_name",
      headerName: "Account Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "interest_over_a_year",
      headerName: "Interest Over a Year (%)",
      flex: 1,
    },
    {
      field: "is_refundable",
      headerName: "Is Refundable",
      flex: 1,
      type: "boolean",
    },
    {
      field: "in_out",
      headerName: "Inflow/Outflow",
      flex: 1,
    },
    {
      field: "in_ex",
      headerName: "Inflow/Expenditure",
      flex: 1,
    },
    {
      field: "as_li",
      headerName: "Asset/Liability",
      flex: 1,
    },
    {
      field: "stamp_value",
      headerName: "Stamp value",
      flex: 1,

      renderCell: (params) =>
        params.value === null ? "no stamps" : params.value,
    },
    {
      field: "update",
      type: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <AccountActions {...{ params, getSavingsAccount }} />
      ),
    },
    // {
    //   field: "actions",
    //   headerName: "Open",
    //   type: "actions",
    //   flex: 1,
    //   getActions: (params: GridRowParams) => [
    //     <GridActionsCellItem
    //       icon={<FileOpenOutlined />}
    //       onClick={() => takeMe(params.row.id)}
    //       label="Open"
    //     />,
    //   ],
    // },
  ];

  const takeMe = () => {
    if (permissions && permissions.view_savings_account === true) {
      navigate("/savings/account", { state: { id: 0, accounts: allSavings } });
    } else {
      toast.error("Not Allowed");
    }
  };

  const createSavings = async (event) => {
    event.preventDefault();
    try {
      await api
        .post("/account/savings", savingsData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          setSavingsData({
            account_name: "",
            interest_over_a_year: null,
            is_refundable: false,
            medium_of_exchange: "",
            stamp_value: null,
            in_out: "",
            in_ex: "",
            as_li: "",
          });
          getSavingsAccount();
          setOpen(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Accounts" subtitle="All Accounts" />
          </Box>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                centered
              >
                <Tab label="Savings Accounts" {...a11yProps(0)} />
                <Tab label="Loans Accounts" {...a11yProps(1)} />
                <Tab label="Shares Accounts" {...a11yProps(2)} />
                {/* <Tab label="Commodity Accounts" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Card sx={{ minWidth: 280, margin: 4 }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Saving Accounts
                  </Typography>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {permissions &&
                    permissions.create_savings_account === true ? (
                      <Button variant="outlined" onClick={handleClickOpen}>
                        Setup Savings Account
                      </Button>
                    ) : null}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button></Button>
                </CardActions>
              </Card>
              <Divider variant="middle" />
              <Box
                m="40px 0 0 0"
                height="75vh"
                paddingBottom="35px"
                sx={{
                  "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: "white",
                  },
                }}
              >
                <Chip
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Go to Dashboards</b>
                      </Typography>
                    }
                    size="medium"
                    variant="outlined"
                    sx={{
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor:"#2b2d42",
                      color:"#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                        color: "#000",
                      },
                    }}
                    onClick={takeMe}
                  />
                

                <DataGrid
                  rows={allSavings}
                  columns={savingsColumns}
                  checkboxSelection
                  slots={{ toolbar: GridToolbar }}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                  }}
                />
              </Box>

              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Setup Savings Account</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    You will be able to open {savingsData.account_name} Accounts
                    after the setup.
                  </DialogContentText>
                  <TextField
                    required
                    margin="dense"
                    id="account_name"
                    name="account_name"
                    label="Account Name"
                    onChange={handleInputChange}
                    value={savingsData.account_name}
                    type="text"
                    fullWidth
                    variant="outlined"
                  />
                  <p>Saves In</p>
                  <Select
                    required
                    margin="dense"
                    id="medium_of_exchange"
                    name="medium_of_exchange"
                    value={savingsData.medium_of_exchange}
                    label="Money Type"
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                  >
                    <MenuItem value="cash">Cash</MenuItem>
                    <MenuItem value="stamps">Stamps</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                  </Select>

                  <TextField
                    required
                    margin="dense"
                    id="interest_over_a_year"
                    name="interest_over_a_year"
                    label="Interest Over A Year (%)"
                    onChange={handleInputChange}
                    type="number"
                    value={savingsData.interest_over_a_year}
                    fullWidth
                    variant="outlined"
                  />
                  {savingsData.medium_of_exchange === "stamps" ||
                  savingsData.medium_of_exchange === "both" ? (
                    <TextField
                      margin="dense"
                      name="stamp_value"
                      label="Specify Stamp value"
                      onChange={handleInputChange}
                      type="number"
                      value={savingsData.stamp_value}
                      fullWidth
                      variant="outlined"
                    />
                  ) : null}

                  <p>Is Refundable?</p>
                  <input
                    name="is_refundable"
                    id="is_refundable"
                    type="checkbox"
                    value={savingsData.is_refundable}
                    onChange={handleInputChange}
                  />
                  <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={savingsData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={savingsData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={savingsData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={createSavings}>Create</Button>
                </DialogActions>
              </Dialog>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <LoanAccounts />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <ShareAccounts />
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={3}>
                                                <CommodityAmount />
                                            </CustomTabPanel> */}
          </Box>
        </Box>
      </main>
    </div>
  );
};
export default Accounts;
